<script>
    import PreviewComponent from "./PreviewComponent";
    import BundleDataComponent from "../../components/pagesbuilder/dynamic-components/BundleDataComponent";
    export default {
        name: "PreviewBundleDataComponent",
        mixins: [
            PreviewComponent,
            BundleDataComponent,
        ]
    }
</script>
